import { Component, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import {formatDate } from '@angular/common';

@Component({
    selector: '[banner]',
    templateUrl: 'banner.component.html',
    styleUrls: ['./banner.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BannerComponent {

  today= new Date();
  todaysTime = '';
  todaysDate = '';
  constructor(private changeDetectorRef: ChangeDetectorRef) {
    this.todaysDate = formatDate(this.today, 'MMM dd, yyyy', 'en-US');
    this.todaysTime = formatDate(this.today, 'hh:mm a', 'en-US');

  }

}
